<template>
  <div>
    <van-pull-refresh v-model="loading" @refresh="refresh()">
      <div style="height: 100vh">
        <!--轮播图-->
        <div class="limg">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in (record.picUrls || '').split(',')" :key="index">
              <img :src="fileDisplayPrefix + item" style="width: 100%;"/>
              <!--<img src="../../assets/timg.png" style="width: 100%;"/>-->
            </van-swipe-item>
          </van-swipe>
        </div>

        <!--简介-->
        <div class="introduce">
          <span><h2>场馆简介</h2> <img src="../../assets/map.png"/></span>
          <p v-html="record.remark"></p>
        </div>

        <!--类型选择-->
        <div class="chang">
          <h3 class="title clearfiex">类型选择</h3>

            <div class="d-list" v-for="(item, index) in (record.sportList || [])" :key="index" style="display:flex;">
                <!--<img src="@/assets/imgstyle.png"/>-->
                <img :src="fileDisplayPrefix + item.picUrl"/>
                <div class="d-info">
                  <h4>{{getDictName(sportTypeList, item.sportType)}}</h4>
                  <span>场地数量：{{item.count || 0}}</span>
                  <p>
                    <span>价格：</span>
                    <span v-if="!item.minPrice || !item.maxPrice || item.maxPrice === item.minPrice">
                      {{item.maxPrice || item.minPrice || 0}}
                    </span>
                    <span v-else>
                      {{item.minPrice}}-{{item.maxPrice || item.minPrice || 0}}
                    </span>
                    <span>/{{getDictName(chargeTypeOptions, item.chargeType)}}</span>


                  </p>
                </div>

              <div class="yue-but clearfiex">
                <button @click="toReserve(item)">预约</button>
              </div>

            </div>

        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {get} from '@/api/venue/venue'

  export default {
    name: 'venueDetail',
    components: {},
    data() {
      return {
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        id: '',
        record: {},
        chargeTypeOptions: [],
        sportTypeList: [],
        getDictName,
        loading: false
      }
    },
    computed: {},
    created() {
      this.id = this.$route.query.id
      this.refresh()
    },
    mounted() {
    },
    methods: {
      refresh() {
        this.getDict()
        this.getDetail()
      },
      getDetail() {
        get(this.id).then(res => {
          if (res.code === 10000) {
            this.record = res.result
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 100)
        })
      },
      getDict() {
        // 查询字典，收费类型
        getDictByType('charge_type').then(res => {
          if (res.code === 10000) {
            this.chargeTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        })
        // 查询字典，获取状态
        getDictByType('sport_type').then(res => {
          if (res.result) {
            this.sportTypeList = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        })
      },
      toReserve(item) {
        this.$store.commit('setVenueInfo', item)
        this.$router.push({name: 'venueReserve', query: { venueId: item.venueId, sportType: item.sportType }})
      }
    }
  }
</script>

<style scoped>
.title{
  display: flex;
  align-items: center;
  padding:15px 0;
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  position: relative;
  padding-left: 10px;
}
.title::after{
  position: absolute;
  left: 0;
  width:4px;
  height:16px;
  background: #2C68E4;
  border-radius: 6px;
}
.limg{
  height:236px;
  overflow: hidden;
}
.introduce{
  background: #ffffff;
  padding: 0 10px;
  padding-bottom: 20px;
}
.introduce span{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:20px 0 10px 0;
}
.introduce h2{
  display: flex;
  align-items: center;
  font-size:18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.introduce span img{
  display: flex;
  width: 23px;
  height: 23px;
}
.introduce p{
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height:21px;
}
.chang{
  background: #ffffff;
  margin-top: 10px;
  padding: 0 10px;
  padding-bottom: 10px;
}
.d-list{
  height:80px;
  background: #FFFFFF;
  border: 1px solid #DEDEDE;
  box-shadow: 0px 0px 20px 0px rgba(12,3,6,0.1);
  border-radius:6px;
  margin: 5px 0;
  padding: 6px;
  display: flex;
  justify-content: space-between;
}
.d-list img{
  display: flex;
  width:98px;
  height:68px;
}
.yue-but{
  display: flex;
  width:75px;
  align-items: center;
  justify-content: center;
  position: relative;
}
.yue-but button{
  display: flex;
  width:59px;
  height:28px;
  background: #2C68E4;
  border-radius: 3px;
  border: none;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
.yue-but::after{
  position: absolute;
  left: 0;
  width: 0px;
  height:67px;
  border: 1px solid;
  border-image: linear-gradient(0deg, #FFFFFF, #DEDEDE, #FFFFFF)1 1;
}
.d-info{
  display: flex;
  flex: 1;
  padding: 0 5px;
  flex-direction: column;
}
 .d-info h4{
   font-size:16px;
   font-family: PingFang SC;
   font-weight: bold;
   color: #000000;
   display: flex;
   padding-bottom: 10px;
   overflow:hidden;
   text-overflow:ellipsis;
   display:-webkit-box;
   -webkit-line-clamp:1;
   -webkit-box-orient:vertical;
 }
.d-info span{
  display: flex;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin-bottom: 10px;
}
.d-info p{
  display: flex;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
</style>
